<template>
    <v-select v-bind="$attrs"
              v-on="$listeners"
              v-model="m_value"
              :items="m_items"
              menu-props="offsetY"
              validate-on-blur
              solo flat>
        <select-arrow slot="append"></select-arrow>
    </v-select>
</template>

<script>
import SelectArrow from '../components/SelectArrow'

export default {
  name: 'MSelect',
  components: { SelectArrow },
  props: {
    'value': [String, Number, Array, Object],
    'items': Array
  },
  data: () => ({
    m_items: [],
    m_value: []
  }),
  watch: {
    items (val) {
      this.m_items = val
    },
    value (val) {
      this.m_value = val
    },
    m_value (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.m_items = this.items
    this.m_value = this.value
  }
}
</script>
